import '../DataCollection.css';
import { useForm } from "react-hook-form";
import { useState } from "react";

/*
* TextInput
* The best way to use this is to pass in the state object that has an attribute of the value you want to manage, the name of the variable in that state that you want to manage,
* and a function to update that state.  The onChange function will be called with the event object, and the state will be updated with the new value.
*
* EXAMPLE - this manages the firstName attribute of the subscriber object in the state, and updates it with the setSubscriber function:
    <TextInput
        label={t('Given Name')}
        name={'firstName'}
        state={state.subscriber}
        onChange={handleChange(state.setSubscriber)}
        validationRules={{required: true}}
    />

 */
const TextInput = ({ label, placeholder, value, name, state, validationRules, validationCallback = undefined, onChange, validationFailedMessage = 'Invalid value entered', innerRef, fullWidth = false, ...rest }) => {
    const { register, handleSubmit, watch, formState: { errors } } = useForm({ mode: 'onBlur' });
    const [validationFailed, setValidationFailed] = useState(false);

    const _onBlur = (e) => {

        let text = e.target.value;

        setValidationFailed(false);

        if (validationCallback) {
            text = validationCallback(text);
            if (text === '' && e.target.value !== '') {
                setValidationFailed(true);
            }
        }

        if (text !== '' && validationRules && validationRules.pattern && validationRules.pattern.value) {
            if (!new RegExp(validationRules.pattern.value).test(text)) {
                text = '';
                setValidationFailed(true);
            }
        }

        const newEvent = {
            target: {
                name: e.target.name,
                value: text
            }
        }

        onChange(newEvent);
    }

    if (state && name !== undefined) {
        value = state[name];
    }

    if (name === undefined) {
        console.error(`name is undefined for text input label: ${label}, placeholder: ${placeholder}`);
        name = "UNDEFINED!"
        placeholder = "UNDEFINED!"

        onChange = (e) => {
            console.error(`name is undefined for text input cannot store value! label: ${label}, placeholder: ${placeholder}`)
        }
    }

    if (validationRules) {
        //TODO: This was added for custom validation but may not be needed anymore
        validationRules = (validationRules[state] || {})[name] || validationRules;
    }

    let errorClass = errors[name] ? 'error' : '';

    const wrapperClassName = fullWidth
        ? 'form-input-area__input form-input-area__input--full-width'
        : 'form-input-area__input';

    return (
        <div className={wrapperClassName}>
            <label>
                {label && <span>{label} </span>}
                <input {...register(name, validationRules)}
                    type="text"
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    className={errorClass}
                    onBlur={_onBlur}
                    ref={innerRef}
                    {...rest}
                />
                {validationRules && validationRules.required && <span className={'required-input'}>*</span>}
            </label>
            {validationFailed &&
                <div className={'error-message'}>{validationFailedMessage}</div>
            }
        </div>
    )
}

export default TextInput;